import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: { 
    TeamMemberList: [],
    TeamMemberListType:'',
    TeamMemberList2:[], 
    AllRetreatFlag:false,
    AllRetreatOnLineSN:{},
    GroupRetreatFlag:'',
    GroupRetreatOnLineSN:{},
    IsTrereatState:{},
    RetreatData:[],
    IsResponse:{},
    Config:{},
    CurrentLocation:{},
    NullLocationList:[],
    ReccoTeamMemberList:{},
    TeamMemberLists: [],
    TeamMemberGroups:[],
    AllTeamMember:[],
    LocationInfo:[],
    troopInfo:{}  
  },
  mutations: { 
    setTroopInfo(state,data){
      state.troopInfo = data;
    },
    setTeamMemberList(state, data) {
      state.TeamMemberList = data;
    },
    setTeamMemberListType(state, data) {
      state.TeamMemberListType = data;
    },
    setTeamMemberList2(state, data) {
      state.TeamMemberList2 = data;
    }, 
    setAllRetreatFlag(state, data) {
      state.AllRetreatFlag = data;
    },
    setAllRetreatOnLineSN(state, data){
      state.AllRetreatOnLineSN[data] = data;
    },
    setGroupRetreatFlag(state, data) {
      state.GroupRetreatFlag = data;
    },
    setGroupRetreatOnLineSN(state, data) {
      state.GroupRetreatOnLineSN[data]=data;
    },
    setIsTrereatState(state, data) {
      state.IsTrereatState[data] = true;
    },
    setRetreatData(state, data) {
      state.RetreatData = data;
    },
    setIsResponse(state, data) {
      if(data.type){
        state.IsResponse[data.data] = true;
      }else{
        state.IsResponse[data.data] = false;
      }
    },
    clearIsResponse(state, data){
      state.IsResponse={}
    },
    setConfig(state, data) { 
      state.Config = data;
    },
    setCurrentLocation(state, data) {
      state.CurrentLocation = data;
    },
    setNullLocationList(state,data){
      state.NullLocationList = data;
    },
    setReccoTeamMemberList(state,data){
      state.ReccoTeamMemberList = data;
    },
    setTeamMemberLists(state, data) {
      state.TeamMemberLists = data;
    },
    setTeamMemberListsByAdd(state, data) {
      state.TeamMemberLists.push(data)
    },
    setTeamMemberListsBySN(state, data) { 
      for (var i = 0; i < state.TeamMemberLists.length; i++) {
        if(state.TeamMemberLists[i].SN==data.SN){
          state.TeamMemberLists.splice(i,1,data)
        }
      } 
    },
    setTeamMemberGroups(state,data){
      state.TeamMemberGroups = data;
    },
    setAllTeamMember(state,data){
      state.AllTeamMember = data;
    },
    setLocationInfo(state,data){
       state.LocationInfo = data;
    }
  },
  actions: {
    SetAllRetreatFlag:({commit},data)=>commit('setAllRetreatFlag',data), 
    SetTroopInfo:({commit},data)=>commit('setTroopInfo',data),  
    SetAllRetreatOnLineSN:({commit},data)=>commit('setAllRetreatOnLineSN',data),
    SetGroupRetreatFlag:({commit},data)=>commit('setGroupRetreatFlag',data),
    SetGroupRetreatOnLineSN:({commit},data)=>commit('setGroupRetreatOnLineSN',data),
    SetIsTrereatState:({commit},data)=>commit('setIsTrereatState',data),
    SetTeamMemberList:({commit},data)=>commit('setTeamMemberList',data),
    SetTeamMemberListType:({commit},data)=>commit('setTeamMemberListType',data),
    SetTeamMemberList2:({commit},data)=>commit('setTeamMemberList2',data), 
    SetRetreatData:({commit},data)=>commit('setRetreatData',data),
    SetIsResponse:({commit},data)=>commit('setIsResponse',data),
    ClearIsResponse:({commit},data)=>commit('clearIsResponse',data),
    SetConfig:({commit},data)=>commit('setConfig',data),
    SetCurrentLocation:({commit},data)=>commit('setCurrentLocation',data),
    SetNullLocationList:({commit},data)=>commit('setNullLocationList',data),
    setReccoTeamMemberList:({commit},data)=>commit('setReccoTeamMemberList',data)
  }
})
